﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customAdSetting from './tpl/customAdSetting.html';

import language from '../../../common/language';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';

import config from '../../../common/config';
import Help from '../../helper/help';
import View_Render from '../render/render';

import View_CustomHeader from '../region/customHeader/customHeader';

import * as FileApi from 'fileapi';

import * as FilePond from 'filepond';

import FilePondPluginFileEncode from '../../plugins/filepond-plugin-file-encode';
import FilePondPluginImageCrop from '../../plugins/filepond-plugin-image-crop';
import FilePondPluginImageResize from '../../plugins/filepond-plugin-image-resize';
import FilePondPluginImageTransform from '../../plugins/filepond-plugin-image-transform';
import FilePondPluginImagePreview from '../../plugins/filepond-plugin-image-preview';
import FilePondPluginImageEdit from '../../plugins/filepond-plugin-image-edit';
import FilePondPluginImageSizeMetaData from '../../plugins/filepond-plugin-image-size-metadata';

import helper_typo from '../../helper/typo';

export default View_LayoutError.extend({
    designRegion: '#designRegion_modal',
    getTemplate: function () {
        if (this.options.designMode) {
            return tpl_customAdSettingDesign({ model: this.model.toJSON() });
        } else {
            return tpl_customAdSetting({ model: this.model.toJSON() });
        }
    },
    regions: {
        information: "#customAdSettingInformation",
        customHeader: "#customHeader"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();

        if (this.model) {
            customHeaderModel.attributes.Name = this.model.attributes.Name;
        } else {
            customHeaderModel.attributes.Name = "";
        }

        customHeaderModel.attributes.Title = resources.X101264;
        customHeaderModel.attributes.ShowSave = true;
        customHeaderModel.attributes.ShowBack = true;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    initialize: function () {
        var self = this;

        this.app = this.options.app;
        

        this.informationCollection = new Entities_Empty.Collection();

        this.listenTo(this.collection, 'add', this.updateInformationCollection, this);
        this.listenTo(this.collection, 'remove', this.updateInformationCollection, this);

        this.localSetting = new Entities_Empty.Model();
        this.localSetting.attributes.EventId = -1;
        this.localSetting.attributes.ImageSelected = false;

        this.setHasChanged(false);
        this.oldModel = this.model.clone();

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.btnSubmitClick(null);
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
            self.customAdSetting_btnBack_click();
        });
    },
    ui: {
        'customAdImageInsert_filePond': '#customAdImageInsert_filePond',
        'customAdSetting_divAd': '#customAdSetting_divAd',
        'customAdSetting_img_AdImage': '#customAdSetting_img_AdImage',
        'customAdSetting_btnAd': '#customAdSetting_btnAd',
        'customAdSetting_btnDelete': '#customAdSetting_btnDelete',
        'customAdSetting_selectAdImageId': '#customAdSetting_selectAdImageId',
        'customAdSetting_inputAdImageUrl': '#customAdSetting_inputAdImageUrl',
        'customAdSetting_labelAdStatus': '#customAdSetting_labelAdStatus',
        'customAdSetting_imageAdImageId': '#customAdSetting_imageAdImageId',

        'customAdSetting_divAdBig': '#customAdSetting_divAdBig',
        'customAdSetting_img_AdBigImage': '#customAdSetting_img_AdBigImage',
        'customAdSetting_btnAdBig': '#customAdSetting_btnAdBig',
        'customAdSetting_selectAdBigImageId': '#customAdSetting_selectAdBigImageId',
        'customAdSetting_inputAdBigImageUrl': '#customAdSetting_inputAdBigImageUrl',
        'customAdSetting_labelAdBigStatus': '#customAdSetting_labelAdBigStatus',
        'customAdSetting_imageAdBigImageId': '#customAdSetting_imageAdBigImageId',

        'customAdSettingInformation': '#customAdSettingInformation',

        'help': '#help',
        'customAdSetting_btnSubmit': '#customAdSetting_btnSubmit',
        'customAdSetting_btnBack': '#customAdSetting_btnBack',
        'customAdImageInsert_image': '#customAdImageInsert_image',
        'customAdImageInsert_btn_crop_zoom_plus': '#customAdImageInsert_btn_crop_zoom_plus',
        'customAdImageInsert_btn_crop_zoom_minus': '#customAdImageInsert_btn_crop_zoom_minus',
        'customAdImageInsert_btn_crop_move_left': '#customAdImageInsert_btn_crop_move_left',
        'customAdImageInsert_btn_crop_move_right': '#customAdImageInsert_btn_crop_move_right',
        'customAdImageInsert_btn_crop_move_top': '#customAdImageInsert_btn_crop_move_top',
        'customAdImageInsert_btn_crop_move_buttom': '#customAdImageInsert_btn_crop_move_buttom',
        'customAdImageInsert_btn_crop_rotate_left': '#customAdImageInsert_btn_crop_rotate_left',
        'customAdImageInsert_btn_crop_rotate_right': '#customAdImageInsert_btn_crop_rotate_right',
        'customAdImageInsert_btn_crop_scale_x': '#customAdImageInsert_btn_crop_scale_x',
        'customAdImageInsert_btn_crop_scale_y': '#customAdImageInsert_btn_crop_scale_y',
        'customAdImageInsert_btn_crop_aspectRatio_5_5': '#customAdImageInsert_btn_crop_aspectRatio_5_5',
        'customAdImageInsert_btn_crop_aspectRatio_4_3': '#customAdImageInsert_btn_crop_aspectRatio_4_3',
        'customAdImageInsert_btn_crop_aspectRatio_3_4': '#customAdImageInsert_btn_crop_aspectRatio_3_4',
        'customAdImageInsert_btn_crop_aspectRatio_6_4': '#customAdImageInsert_btn_crop_aspectRatio_6_4',
        'customAdImageInsert_btn_crop_aspectRatio_4_6': '#customAdImageInsert_btn_crop_aspectRatio_4_6',
        'customAdImageInsert_btn_crop_aspectRatio_Free': '#customAdImageInsert_btn_crop_aspectRatio_Free'
    },
    events: {
        'click @ui.customAdSetting_btnAd': 'customAdSetting_btnAdClick',
        'click @ui.customAdSetting_btnDelete': 'customAdSetting_btnDeleteClick',
        'click @ui.customAdSetting_btnAdBig': 'customAdSetting_btnAdBigClick',
        'click @ui.customAdSetting_btnSubmit': 'btnSubmitClick',
        'click #help': 'help',
        'click @ui.designRegion_btnOk': 'designRegion_btnOk',
        'click @ui.customAdSetting_btnBack	': 'customAdSetting_btnBack_click',
        'click @ui.customAdImageInsert_btn_crop_zoom_plus': 'btnZoomPlusClick',
        'click @ui.customAdImageInsert_btn_crop_zoom_minus': 'btnZoomMinusClick',
        'click @ui.customAdImageInsert_btn_crop_move_left': 'btnMoveLeftClick',
        'click @ui.customAdImageInsert_btn_crop_move_right': 'btnMoveRightClick',
        'click @ui.customAdImageInsert_btn_crop_move_top': 'btnMoveTopClick',
        'click @ui.customAdImageInsert_btn_crop_move_buttom': 'btnMoveButtomClick',
        'click @ui.customAdImageInsert_btn_crop_rotate_left': 'btnRotateLeftClick',
        'click @ui.customAdImageInsert_btn_crop_rotate_right': 'btnRotateRightClick',
        'click @ui.customAdImageInsert_btn_crop_scale_x': 'btnScaleXClick',
        'click @ui.customAdImageInsert_btn_crop_scale_y': 'btnScaleYClick',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_5_5': 'btnAspectRatio_5_5_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_4_3': 'btnAspectRatio_4_3_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_3_4': 'btnAspectRatio_3_4_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_6_4': 'btnAspectRatio_6_4_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_4_6': 'btnAspectRatio_4_6_Click',
        'click @ui.customAdImageInsert_btn_crop_aspectRatio_Free': 'btnAspectRatio_Free_Click'
    },
    onRender: function () {
        this.setupEvent();
        this.renderInformation();

        if (this.app.mode == 1) {
            this.ui.customAdSetting_btnSubmit.css('display', 'none');
            this.ui.customAdSetting_btnBack.css('display', 'none');
        }

        this.setupAd();
        this.setupAdBig();

        return this;
    },
    renderInformation: function () {
        this.informationCollection.reset();

        if (app.entities.models.configSubscription[0].attributes.EnableAdvertising == false) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X101470 });
            this.informationCollection.add(tmpModel);
        }

        this.app.renderInformation({ informationCollection: this.informationCollection });
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    customAdSetting_btnAdClick() {
        var self = this;
        //this.setupFancyBoxAd();

        var searchString = ";base64,";
        var pos = 0;
        var uuid = this.UUID();

        var strUtcDate = helper_typo.getDBUtcDataTime();

        var image515 = this.getWeboptimizeImage(640, 100);

        var imageData512 = image515.data;
        pos = imageData512.indexOf(searchString);
        var imageMimeType512 = imageData512.substring(5, pos);
        imageData512 = imageData512.substring(pos + searchString.length, imageData512.length);

        var sizeText = Math.round(image515.width) + 'X' + Math.round(image515.height);

        //var filename = resources.X101451 + " - " + this.localSetting.attributes.FileName;
        var filename = helper_typo.getUTCUnicDataTimrId();

        var callbackSaveImage = function (tmpModel) {
            var model = self.app.entities.collections.customAdImage.fullCollection.where({ id: tmpModel.attributes.id })[0];
            self.model.attributes.AdImageId = model.attributes.id;
            self.ui.customAdSetting_img_AdImage.attr('src', model.attributes.ImageUrl + '?bust=' + strUtcDate);

            self.model.save(self.model.attributes, {
                silent: true,
                wait: true,
                success: function () {
                }
            });
        }


        this.saveImage(filename, resources.X100500, resources.X101289, imageData512, imageMimeType512, 1, sizeText, 0, uuid, strUtcDate, callbackSaveImage);

    },
    customAdSetting_btnDeleteClick() {
        var self = this;
        var model = self.app.entities.collections.customAdImage.fullCollection.where({ id: this.model.attributes.AdImageId })[0];

        var collection = this.app.entities.collections.customAdImage;

        model.destroy({
            wait: true,
            success: function (model, response) {
                collection.fullCollection.sort();
                if (collection.state.currentPage < collection.state.lastPage) {
                    collection.getPage(collection.state.currentPage);
                }
                else {
                    collection.getLastPage();
                }
                self.model.attributes.AdImageId = -1;
                
                self.ui.customAdSetting_img_AdImage.attr('src', '');

                self.model.save(self.model.attributes, {
                    silent: true,
                    wait: true,
                    success: function () {
                    }
                });
            },
            error: function (model, response) {
            }
        });

    },
    customAdSetting_btnAdBigClick() {
        this.setupFancyBoxAdBig();
    },
    setupFancyBoxStyle() {
        var top = window.innerHeight * 0.1;
        var left = window.innerWidth * 0.1;
        $('.fancybox-container').css('max-width', '80%');
        $('.fancybox-container').css('max-height', '80%');
        $('.fancybox-container').css('left', left + 'px');
        $('.fancybox-container').css('top', top + 'px');
    },
    setupFancyBoxAdOnLoad() {
        if (this.model.attributes.AdImageId != -1) {
            var model = this.app.entities.collections.customAdImage.fullCollection.where({ id: this.model.attributes.AdImageId })[0];
            this.ui.customAdSetting_img_AdImage.attr('src', model.attributes.ImageUrl);
        }
    },
    setupFancyBoxAd() {
        var self = this;
        var list = [];

        var model = this.app.entities.collections.customAdImage.fullCollection.where({ SizeType: 1 });

        model.forEach(function (entry) {
            var s   

            if (self.model.attributes.AdImageId == entry.attributes.id) {
                var item = {
                    src: entry.attributes.ImageUrl,
                    opts: {
                        caption: '',
                        thumb: "'" + entry.attributes.ImageUrl + "'"
                    }
                }

                list.push(item);
            }
        });

        model.forEach(function (entry) {
            var s

            if (self.model.attributes.AdImageId != entry.attributes.id) {
                var item = {
                    src: entry.attributes.ImageUrl,
                    opts: {
                        caption: '',
                        thumb: "'" + entry.attributes.ImageUrl + "'"
                    }
                }

                list.push(item);
            }
        });

        $.fancybox.open(
            list,
            {
                loop: false,
                thumbs: {
                    autoStart: true, // Display thumbnails on opening
                    hideOnClose: true, // Hide thumbnail grid when closing animation starts
                    parentEl: ".fancybox-container", // Container is injected into this element
                    axis: "y" // Vertical (y) or horizontal (x) scrolling
                },
                opts: {

                },
                beforeClose: function (instance, current) {
                    var model = self.app.entities.collections.customAdImage.fullCollection.where({ ImageUrl: current.src })[0];
                    self.model.attributes.AdImageId = model.attributes.id;
                    self.ui.customAdSetting_img_AdImage.attr('src', current.src);
                    //self.model.attributes.AdImageUrl = current.src;
                },
                clickContent: "close",
                clickSlide: "close",
                clickOutside: "close"
            }
        );

        this.setupFancyBoxStyle();

        
    },
    setupAd: function () {
        /*if (app.entities.models.configSubscription[0].attributes.EnableAdvertising == false) {
            this.ui.customAdSetting_div_Ad.show();

            this.ui.customAdSetting_selectAdEnable.val(this.model.attributes.AdEnable);

            this.setupAdImageId();
        }
        else {
            this.setupAdImageId();
            this.ui.customAdSetting_div_Ad.css('display', 'none');
        }*/
        this.setupAdImageId();
    },
    setupAdImageId: function () {
        var self = this;
        var model = this.app.entities.collections.customAdImage.fullCollection.where({ SizeType: 1 });

        /*if (self.model.attributes.AdImageId == -1) {
            self.ui.customAdSetting_selectAdImageId.append('<option value="' + -1 + '" selected="selected">' + resources.X100292 + '</option>');
        }
        else {
            self.ui.customAdSetting_selectAdImageId.append('<option value="' + -1 + '">' + resources.X100292 + '</option>');
        }

        model.forEach(function (entry) {
            if (self.model.attributes.AdImageId == entry.attributes.id) {
                var s = '<option  style="background-image:url({0})" value="{1}" selected="selected">{2}</option>';
                //self.ui.customAdSetting_selectAdImageId.append('<option value="' + entry.attributes.id + '" selected="selected">' + entry.attributes.Name + '</option>');
                self.ui.customAdSetting_selectAdImageId.append(String.format(s, entry.attributes.ImageUrl, entry.attributes.id, entry.attributes.Name));
            } else {
                var s = '<option  style="background-image:url({0})" value="{1}">{2}</option>';
                //self.ui.customAdSetting_selectAdImageId.append('<option value="' + entry.attributes.id + '">' + entry.attributes.Name + '</option>');
                self.ui.customAdSetting_selectAdImageId.append(String.format(s, entry.attributes.ImageUrl, entry.attributes.id, entry.attributes.Name));
            }
        });*/

        var model = this.app.entities.collections.customAdImage.fullCollection.where({ id: this.model.attributes.AdImageId });

        if (model.length > 0) {
            this.ui.customAdSetting_imageAdImageId.attr('src', model[0].attributes.ImageUrl);
        }

        var status = '';

        switch (this.model.attributes.AdStatus) {
            case 0: status = resources.X100961; break;
            case 1: status = resources.X100962; break;
        }

        this.ui.customAdSetting_labelAdStatus.text(status);
    },
    setupFancyBoxAdBigOnLoad() {


        if (this.model.attributes.AdBigImageId != -1) {
            var model = this.app.entities.collections.customAdBigImage.fullCollection.where({ id: this.model.attributes.AdBigImageId })[0];
            this.ui.customAdSetting_img_AdBigImage.attr('src', model.attributes.ImageUrl);
        }
    },
    setupFancyBoxAdBig() {
        var self = this;
        var list = [];

        var model = this.app.entities.collections.customAdBigImage.fullCollection.where({ SizeType: 1 });

        model.forEach(function (entry) {
            var s

            if (self.model.attributes.AdBigImageId == entry.attributes.id) {
                var item = {
                    src: entry.attributes.ImageUrl,
                    opts: {
                        caption: '',
                        thumb: "'" + entry.attributes.ImageUrl + "'"
                    }
                }

                list.push(item);
            }
        });

        model.forEach(function (entry) {
            var s

            if (self.model.attributes.AdBigImageId != entry.attributes.id) {
                var item = {
                    src: entry.attributes.ImageUrl,
                    opts: {
                        caption: '',
                        thumb: "'" + entry.attributes.ImageUrl + "'"
                    }
                }

                list.push(item);
            }
        });

        $.fancybox.open(
            list,
            {
                
                loop: false,
                thumbs: {
                    autoStart: true, // Display thumbnails on opening
                    hideOnClose: true, // Hide thumbnail grid when closing animation starts
                    parentEl: ".fancybox-container", // Container is injected into this element
                    axis: "y" // Vertical (y) or horizontal (x) scrolling
                },
                opts: {

                },
                beforeClose: function (instance, current) {
                    var model = self.app.entities.collections.customAdBigImage.fullCollection.where({ ImageUrl: current.src })[0];
                    self.model.attributes.AdBigImageId = model.attributes.id;
                    self.ui.customAdSetting_img_AdBigImage.attr('src', current.src);
                    //self.model.attributes.AdBigImageUrl = current.src;
                },
                clickContent: "close",
                clickSlide: "close",
                clickOutside: "close"
            }
        );

        this.setupFancyBoxStyle();
    },
    setupAdBig: function () {
        /*if (app.entities.models.configSubscription[0].attributes.EnableAdBigvertising == false) {
            this.ui.customAdSetting_div_AdBig.show();

            this.ui.customAdSetting_selectAdBigEnable.val(this.model.attributes.AdBigEnable);

            this.setupAdBigImageId();
        }
        else {
            this.setupAdBigImageId();
            this.ui.customAdSetting_div_AdBig.css('display', 'none');
        }*/
        this.setupAdBigImageId();
    },
    setupAdBigImageId: function () {
        var self = this;
        /*if (self.model.attributes.AdBigImageId == -1) {
            self.ui.customAdSetting_selectAdBigImageId.append('<option value="' + -1 + '" selected="selected">' + resources.X100292 + '</option>');
        }
        else {
            self.ui.customAdSetting_selectAdBigImageId.append('<option value="' + -1 + '">' + resources.X100292 + '</option>');
        }

        model.forEach(function (entry) {
            if (self.model.attributes.AdBigImageId == entry.attributes.id) {
                var s = '<option  style="background-image:url({0})" value="{1}" selected="selected">{2}</option>';
                //self.ui.customAdSetting_selectAdBigImageId.append('<option value="' + entry.attributes.id + '" selected="selected">' + entry.attributes.Name + '</option>');
                self.ui.customAdSetting_selectAdBigImageId.append(String.format(s, entry.attributes.ImageUrl, entry.attributes.id, entry.attributes.Name));
            } else {
                var s = '<option  style="background-image:url({0})" value="{1}">{2}</option>';
                //self.ui.customAdSetting_selectAdBigImageId.append('<option value="' + entry.attributes.id + '">' + entry.attributes.Name + '</option>');
                self.ui.customAdSetting_selectAdBigImageId.append(String.format(s, entry.attributes.ImageUrl, entry.attributes.id, entry.attributes.Name));
            }
        });*/

        var model = this.app.entities.collections.customAdBigImage.fullCollection.where({ id: this.model.attributes.AdBigImageId });

        if (model.length > 0) {
            this.ui.customAdSetting_imageAdBigImageId.attr('src', model[0].attributes.ImageUrl);
        }

        var status = '';

        switch (this.model.attributes.AdBigStatus) {
            case 0: status = resources.X100961; break;
            case 1: status = resources.X100962; break;
        }

        this.ui.customAdSetting_labelAdBigStatus.text(status);
    },
    /*selectAdImageIdChange: function (event) {
        event.preventDefault();

        this.model.attributes.AdImageId = parseInt(this.ui.customAdSetting_selectAdImageId.val());

        var model = this.app.entities.collections.customAdImage.fullCollection.where({ id: this.model.attributes.AdImageId });

        if (model.length > 0) {
            this.ui.customAdSetting_imageAdImageId.attr('src', model[0].attributes.ImageUrl);
        }
    },*/
    help: function () {
        Help.help(this, true, 'customSchemaLive');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.save(callback);
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        if (this.model) {
            this.setModel();

            /*if (this.model.attributes.AdImageId != this.oldModel.attributes.AdImageId) {
                changes = true;
            }*/

            if (this.model.attributes.AdImageUrl != this.oldModel.attributes.AdImageUrl) {
                changes = true;
            }

        //    if (this.model.attributes.AdBigImageId != this.oldModel.attributes.AdBigImageId) {
        //        changes = true;
        //    }

        //    if (this.model.attributes.AdBigImageUrl != this.oldModel.attributes.AdBigImageUrl) {
        //        changes = true;
        //    }
        }

        this.setHasChanged(changes);
    },
    
    customViewEvent_setActive: function () {
        var array = [];

        if (this.localSetting.attributes.EventId != -1) {
            var tmp = { "id": this.localSetting.attributes.EventId };
            array.push(tmp);
        }

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customViewEvent:setActive', array);
    },
    onAttach() {
        this.customViewEvent_setActive();

        if (this.options.designMode) {
            var height = $(window).height() * 0.8;
            this.ui.designRegion_body.height(height);
        }

        //this.setupFancyBoxAdOnLoad();
        //this.setupFancyBoxAdBigOnLoad();

        if (this.model.attributes.AdImageId != -1) {
            var model = this.app.entities.collections.customAdImage.fullCollection.where({ id: this.model.attributes.AdImageId })[0];

            if (model != null)
                this.ui.customAdSetting_img_AdImage.attr('src', model.attributes.ImageUrl);
        }

        var self = this;
        FilePond.registerPlugin(
            FilePondPluginFileEncode,
            FilePondPluginImageCrop,
            FilePondPluginImageResize,
            FilePondPluginImageTransform,
            FilePondPluginImagePreview,
            FilePondPluginImageEdit,
            FilePondPluginImageSizeMetaData
        );

        var labelIdle = resources.X101435 + ' <span class="filepond--label-action">' + resources.X101437 + '</span>';

        var pond = FilePond.create(this.ui.customAdImageInsert_filePond[0], {
            labelIdle: [
                labelIdle,
                ''
            ],
            allowMultiple: false,
            //allowReorder: true,
            allowFileEncode: true,
            //allowImageCrop: true,
            //imageCropAspectRatio:"1:1",
            //allowImageResize: true,
            //imageResizeTargetWidth: 750,
            //imageResizeTargetHeight: 750,
            imageResizeMode: 'contain',
            //imageResizeUpscale: true,
            //imageCropAspectRatio: 1,
            allowImageTransform: true,
            //allowImagePreview: true,
            //allowImageEdit:true,

            onaddfile: (err, fileItem) => {
                if (err == null) {
                    var base64 = fileItem.getFileEncodeDataURL();

                    self.localSetting.attributes.ImageSelected = true;

                    if (self.cropper) {
                        self.cropper.destroy();
                    }
                    self.ui.customAdImageInsert_image.attr('src', base64);
                    //self.ui.customImageInsert_roundImage.attr('src', base64);

                    //var mimeType = self.base64MimeType(base64);
                    //var fileData = base64.split(',')[1];

                    //self.localSetting.attributes.FileName = fileItem.filenameWithoutExtension;
                    self.localSetting.attributes.FileName = helper_typo.getUTCUnicDataTimrId();

                    var previews = document.querySelectorAll('.cropper-img-preview');
                    var imageDefault = document.querySelector('#customAdImageInsert_image');

                    self.cropper = new Cropper(imageDefault, {
                        aspectRatio: 6 / 1,
                        autoCropArea: 1,
                        zoomOnTouch: false,
                        zoomOnWheel: false,
                        cropBoxResizable: true,
                        build: function () {
                            var clone = this.cloneNode();

                            clone.style.cssText = (
                                'display: block;' +
                                'width: 100%;' +
                                'minWidth: 0;' +
                                'minHeight: 0;' +
                                'maxWidth: none;' +
                                'maxHeight: none;'
                            );
                        },

                        crop: function (e) {
                            var data = e.detail;
                            var cropper = this.cropper;
                            var imageData = cropper.getImageData();
                            var previewAspectRatio = data.width / data.height;
                        }
                    });

                    //self.setupBtn();

                    pond.removeFile(fileItem);
                };
            }
        });
    },
    setupEvent: function () {
        if (app.entities.models.configSubscription[0].attributes.EnableAdvertising == false) {
            this.ui.customAdSetting_btnAd.attr("disabled", true);
            this.ui.customAdSetting_inputAdImageUrl.attr("disabled", true);
            this.ui.customAdSetting_btnAdBig.attr("disabled", true);
            this.ui.customAdSetting_inputAdBigImageUrl.attr("disabled", true);
        }
    },
    setModel: function () {
        this.model.set({
            //AdEnable: parseInt(this.ui.customAdSetting_selectAdEnable.val()),
            //AdImageId: parseInt(this.ui.customAdSetting_selectAdImageId.val()),
            AdImageUrl: this.ui.customAdSetting_inputAdImageUrl.val(),
            //AdBigImageUrl: this.ui.customAdSetting_inputAdBigImageUrl.val()
        }, { silent: true });
    },
    save: function (callbackRouter) {
        var self = this;

        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100408;
        dialogWaitingModel.attributes.Text = resources.X100409;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        var callback = function (options) {
            self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        }
        this.listenTo(dialogWaiting, "dialog:okclicked", callback);
        this.app.dialogRegion.show(dialogWaiting);

        this.setModel();

        this.model.save(this.model.attributes, {
            silent: true,
            wait: true,
            success: function () {
                dialogWaiting.triggerMethod('dialog:close');
                self.oldModel = self.model.clone();
                callbackRouter();
                //var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ Ad: self.model.attributes.id })
                //var render = new View_Render({ collection: customEvent, app: self.app });
                //self.app.renderRegion.show(render);
                //var renderFinishCallback = function (options) {
                //    if (callbackRouter) {
                //        callbackRouter();
                //    }
                //}
                //render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
            }
        });
    },
    btnSubmitClick: function (event) {
        if (event) {
            event.preventDefault();
        }

        var self = this;

        this.setModel(this.model);

        /*this.model.validateNoBackbone(app, function (ret) {
            var modelErrors = ret;
            if (modelErrors) {
                self.hideErrors();
                self.showErrors(self.model.errors);
            }
            else {*/
                self.hideErrors();

                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100408;
                dialogWaitingModel.attributes.Text = resources.X100409;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

                self.model.save(self.model.attributes, {
                    silent: true,
                    wait: true,
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');
                        self.oldModel = self.model.clone();

                        //var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ Ad: self.model.attributes.id })
                        //var render = new View_Render({ collection: customEvent, app: self.app });
                        //self.app.renderRegion.show(render);
                        //var renderFinishCallback = function (options) {
                        //}
                        //render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
                    }
                });
            //}
        //});
    },
    designRegion_btnOk() {
        this.triggerMethod('dialog:close');

    },
    customAdSetting_btnBack_click: function (event) {
        this.app.router.navigate("#customEventEditItem?id=" + this.options.eventId);
        this.app.router.customEventEditItem(this.options.eventId, this.options.scroll, 5, false, false);
    },
    btnZoomPlusClick: function (event) {
        event.preventDefault();
        this.cropper.zoom(0.1);
    },
    btnZoomMinusClick: function (event) {
        event.preventDefault();
        this.cropper.zoom(-0.1);
    },
    btnMoveLeftClick: function (event) {
        event.preventDefault();
        this.cropper.move(-10, 0);
    },
    btnMoveRightClick: function (event) {
        event.preventDefault();
        this.cropper.move(10, 0);
    },
    btnMoveTopClick: function (event) {
        event.preventDefault();
        this.cropper.move(0, -10);
    },
    btnMoveButtomClick: function (event) {
        event.preventDefault();
        this.cropper.move(0, 10);
    },
    btnRotateLeftClick: function (event) {
        event.preventDefault();
        this.cropper.rotate(-90);
    },
    btnRotateRightClick: function (event) {
        event.preventDefault();
        this.cropper.rotate(90);
    },
    btnScaleXClick: function (event) {
        event.preventDefault();

        switch (this.cropper.getData().scaleX) {
            case 1: this.cropper.scaleX(-1); break;
            case -1: this.cropper.scaleX(1); break;
        }
    },
    btnScaleYClick: function (event) {
        event.preventDefault();

        switch (this.cropper.getData().scaleY) {
            case 1: this.cropper.scaleY(-1); break;
            case -1: this.cropper.scaleY(1); break;
        }
    },
    btnAspectRatio_5_5_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(1);
    },
    btnAspectRatio_4_3_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(4 / 3);
    },
    btnAspectRatio_3_4_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(3 / 4);
    },
    btnAspectRatio_6_4_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(6 / 4);
    },
    btnAspectRatio_4_6_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(4 / 6);
    },
    btnAspectRatio_Free_Click: function (event) {
        event.preventDefault();
        this.cropper.setAspectRatio(NaN);
    },
    getWeboptimizeImage: function (width, height) {
        if (this.cropper) {
            //Calc height
            var cropBoxData = this.cropper.getCropBoxData();
            var aspectRatio = cropBoxData.height / cropBoxData.width;
            height = width * aspectRatio;

            var croppedCanvas;
            var canvas;
            var image;

            // Crop
            croppedCanvas = this.cropper.getCroppedCanvas();

            // Round
            canvas = this.getWeboptimizeCanvas(croppedCanvas, width, height);

            var struct = {
                width: width,
                height: height,
                data: canvas.toDataURL('image/png', 0.5)
            }

            return struct;//canvas.toDataURL();
            //return canvas.toDataURL();
        }
    },
    saveImage: function (filename, filenameText, nameText, imageData, imageMimeType, sizeType, sizeText, sortType, uuid, strUtcDate, callback) {

        var model = self.app.entities.collections.customAdImage.fullCollection.where({ id: this.model.attributes.AdImageId })[0];


        var searchString = ";base64,";
        var pos = 0;

        //var imageDataOriginal = this.getOriginalImage();
        //pos = imageDataOriginal.indexOf(searchString);
        //var imageMimeTypeOriginal = imageDataOriginal.substring(5, pos);
        //imageDataOriginal = imageDataOriginal.substring(pos + searchString.length, imageDataOriginal.length);

        var tmpModel = new this.collection.model();
        //tmpModel.attributes.id = null;
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.EventId = this.options.eventId;
        tmpModel.attributes.Name = filename;//this.ui.customAdImageInsert_inputName.val();// + ' ' + nameText;
        tmpModel.attributes.ImageData = imageData;
        tmpModel.attributes.ImageMimeType = 'image/png'; //imageMimeType;
        tmpModel.attributes.ImageUpdate = true;
        tmpModel.attributes.SizeType = sizeType;
        tmpModel.attributes.SizeText = sizeText;
        tmpModel.attributes.SortType = sortType;
        tmpModel.attributes.CommonId = uuid;
        tmpModel.attributes.UtcDate = strUtcDate;

        if (model != null) {
            tmpModel.attributes.ImageUrl = model.attributes.ImageUrl;
        }
        else {
            tmpModel.attributes.ImageUrl = '';
        }

        //tmpModel.attributes.Filename = filename + '_' + filenameText + '.jpg';
        tmpModel.attributes.Filename = filename + '.png'//'_' + filenameText + '.png';

        this.collection.fullCollection.create(tmpModel, {
            wait: true,
            success: function (response) {
                callback(tmpModel);
            }
        });
    },
    UUID: function () {
        var lut = [];
        for (var i = 0; i < 256; i++) {
            lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
        }

        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;

        return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
            lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
            lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
            lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    },
    getWeboptimizeCanvas: function (sourceCanvas, width, height) {
        var canvas = document.createElement('canvas');

        var context = canvas.getContext('2d');

        canvas.width = width;
        canvas.height = height;
        context.beginPath();
        context.drawImage(sourceCanvas, 0, 0, width, height);

        return canvas;
    },
}, Backbone.Radio.Requests);
